import React from "react";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { messages } from "../messages";
import { WaIcon } from "../WaIcon";

export interface BreadcrumbsItem {
    text: React.ReactNode;
    to?: string;
}

interface Props {
    items: BreadcrumbsItem[];
}

export const Breadcrumbs = ({ items }: Props) => (
    <Breadcrumb className="breadcrumbs">
        <BreadcrumbItem key="home">
            <Link to="/">
                <WaIcon name="home-outline" />
                <FormattedMessage {...messages.home} />
            </Link>
        </BreadcrumbItem>
        {items.map(({ text, to }, i) => {
            let elt: React.ReactNode = text;
            if (to != null) {
                elt = <Link to={to}>{text}</Link>;
            }
            return <BreadcrumbItem key={i}>{elt}</BreadcrumbItem>;
        })}
    </Breadcrumb>
);
